// import React, { useState } from "react";
// import { Button, Typography, Spin, Divider, Alert, Radio, Checkbox, Card } from "antd";
// import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";

// const { Text, Title } = Typography;

// const QuizzesSubject = ({ subject, courseId, onSubmitResult }) => {
//   const [selectedQuizId, setSelectedQuizId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [userAnswers, setUserAnswers] = useState({});

//   const quizzes = subject?.quizzes || [];
//   if (!quizzes.length) return null;

//   const currentQuiz = quizzes[0];
//   const questions = currentQuiz?.questions || [];

//   const handleSubmit = () => {
//     setSubmitted(true);
//     let correctCount = 0;
//     questions.forEach(q => {
//       const correctAnswers = q.answers.filter(a => a.correct).map(a => a.text);
//       const user = userAnswers[q.id];
//       const isCorrect = Array.isArray(user)
//         ? JSON.stringify(user.sort()) === JSON.stringify(correctAnswers.sort())
//         : user === correctAnswers[0];
//       if (isCorrect) correctCount++;
//     });
//     const score = correctCount * 10; // simple notation
//     const isPassed = score > 0;
//     if (onSubmitResult) onSubmitResult(subject.id, isPassed);
//   };

//   const renderQuestion = (q) => {
//     const correctAnswers = q.answers.filter(a => a.correct).map(a => a.text);
//     const user = userAnswers[q.id];
//     const isCorrect = Array.isArray(user)
//       ? JSON.stringify(user.sort()) === JSON.stringify(correctAnswers.sort())
//       : user === correctAnswers[0];

//     return (
//       <Card key={q.id} style={{ marginBottom: 16 }}>
//         <Title level={5}>{q.text}</Title>
//         {q.type === "QCM" ? (
//           <Checkbox.Group
//             value={userAnswers[q.id] || []}
//             onChange={(vals) => setUserAnswers({ ...userAnswers, [q.id]: vals })}
//             disabled={submitted}
//             style={{ display: "flex", flexDirection: "column", gap: 8 }}
//           >
//             {q.answers.map((a, i) => (
//               <Checkbox key={i} value={a.text}>{a.text}</Checkbox>
//             ))}
//           </Checkbox.Group>
//         ) : (
//           <Radio.Group
//             value={userAnswers[q.id]}
//             onChange={(e) => setUserAnswers({ ...userAnswers, [q.id]: e.target.value })}
//             disabled={submitted}
//             style={{ display: "flex", flexDirection: "column", gap: 8 }}
//           >
//             {q.answers.map((a, i) => (
//               <Radio key={i} value={a.text}>{a.text}</Radio>
//             ))}
//           </Radio.Group>
//         )}

//         {submitted && (
//           <div style={{ marginTop: 12 }}>
//             {isCorrect ? (
//               <Alert
//                 type="success"
//                 message={<span><CheckCircleTwoTone twoToneColor="#52c41a" /> Bonne réponse</span>}
//                 description="Explication : Pas d'explication disponible."
//                 showIcon
//               />
//             ) : (
//               <Alert
//                 type="error"
//                 message={<span><CloseCircleTwoTone twoToneColor="#ff4d4f" /> Mauvaise réponse</span>}
//                 description="Explication : Pas d'explication disponible."
//                 showIcon
//               />
//             )}
//           </div>
//         )}
//       </Card>
//     );
//   };

//   return (
//     <div style={{ marginTop: 24 }}>
//       <Divider />
//       <Title level={5}>🤔 Quiz - {subject?.title}</Title>

//       {loading ? (
//         <div style={{ textAlign: "center", padding: 20 }}>
//           <Spin size="large" tip="Chargement du quiz..." />
//         </div>
//       ) : (
//         <>
//           {questions.map(renderQuestion)}

//           {!submitted && (
//             <div style={{ textAlign: "center", marginTop: 20 }}>
//               <Button type="primary" onClick={handleSubmit}>Soumettre le Quiz</Button>
//             </div>
//           )}

//           {submitted && (
//             <div style={{ textAlign: "center", marginTop: 20 }}>
//               <Button onClick={() => {
//                 setSubmitted(false);
//                 setUserAnswers({});
//               }}>Recommencer</Button>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default QuizzesSubject;



// ************** code avec drag and drop option ********

// import React, { useState } from "react";
// import { Button, Typography, Spin, Divider, Alert, Radio, Checkbox, Card } from "antd";
// import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import MatchingQuestionViewer from "./MatchingQuestionViewer"; // adapte le chemin si nécessaire

// const { Text, Title } = Typography;

// const QuizzesSubject = ({ subject, courseId, onSubmitResult }) => {
//   const [loading, setLoading] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [userAnswers, setUserAnswers] = useState({});

//   const quizzes = subject?.quizzes || [];
//   if (!quizzes.length) return null;

//   const currentQuiz = quizzes[0];
//   const questions = currentQuiz?.questions || [];

//   const handleSubmit = () => {
//   setSubmitted(true);
//   let correctCount = 0;

//   questions.forEach(q => {
//     const correctAnswers = q.answers.filter(a => a.correct).map(a => a.text);
//     const user = userAnswers[q.id];

//     let isCorrect = false;

//     if (q.type === "DRAG_DROP") {
//       // user est un tableau [{id, text}]
//       const userTexts = Array.isArray(user) ? user.map(u => u.text) : [];
//       isCorrect = JSON.stringify(userTexts) === JSON.stringify(correctAnswers);
//     } else if (Array.isArray(user)) {
//       isCorrect = JSON.stringify(user.sort()) === JSON.stringify(correctAnswers.sort());
//     } else {
//       isCorrect = user === correctAnswers[0];
//     }
// if (q.type === "MATCHING") {
//   isCorrect = q.answers.every(
//     (pair) => user?.[pair.leftText] === pair.rightText
//   );
// }

//     if (isCorrect) correctCount++;
//   });

//   const score = correctCount * 10;
//   const isPassed = score > 0;

//   if (onSubmitResult) {
//     onSubmitResult(subject.id, isPassed);
//   }
// };


//   const renderQuestion = (q) => {
//     const correctAnswers = q.answers.filter(a => a.correct).map(a => a.text);
//     const user = userAnswers[q.id];
//     const isCorrect = Array.isArray(user)
//       ? JSON.stringify(user.sort()) === JSON.stringify(correctAnswers.sort())
//       : user === correctAnswers[0];


//     return (
//       <Card key={q.id} style={{ marginBottom: 16 }}>
//         <Title level={5}>{q.text}</Title>

//         {q.type === "QCM" && (
//           <Checkbox.Group
//             value={userAnswers[q.id] || []}
//             onChange={(vals) => setUserAnswers({ ...userAnswers, [q.id]: vals })}
//             disabled={submitted}
//             style={{ display: "flex", flexDirection: "column", gap: 8 }}
//           >
//             {q.answers.map((a, i) => (
//               <Checkbox key={i} value={a.text}>{a.text}</Checkbox>
//             ))}
//           </Checkbox.Group>
//         )}

//         {(q.type === "QCU" || q.type === "VRAI_FAUX") && (
//           <Radio.Group
//             value={userAnswers[q.id]}
//             onChange={(e) => setUserAnswers({ ...userAnswers, [q.id]: e.target.value })}
//             disabled={submitted}
//             style={{ display: "flex", flexDirection: "column", gap: 8 }}
//           >
//             {q.answers.map((a, i) => (
//               <Radio key={i} value={a.text}>{a.text}</Radio>
//             ))}
//           </Radio.Group>
//         )}
//         {q.type === "MATCHING" && (
//   <MatchingQuestionViewer
//     key={submitted + JSON.stringify(userAnswers[q.id] || {})}
//     pairs={q.answers || []}
//     questionId={q.id}
//     userAnswers={userAnswers}
//     setUserAnswers={setUserAnswers}
//     disabled={submitted}
//   />
// )}


//         {q.type === "DRAG_DROP" && (
//           <DragDropContext
//             onDragEnd={(result) => {
//               if (!result.destination) return;

//               const items = [...(userAnswers[q.id] || q.answers.map((a, i) => ({ id: `a-${i}`, text: a.text })))];
//               const [removed] = items.splice(result.source.index, 1);
//               items.splice(result.destination.index, 0, removed);

//               setUserAnswers({ ...userAnswers, [q.id]: items });
//             }}
//           >
//             <Droppable droppableId={`droppable-${q.id}`}>
//               {(provided) => (
//                 <div
//                   ref={provided.innerRef}
//                   {...provided.droppableProps}
//                   style={{
//                     border: "1px solid #f0f0f0",
//                     padding: 12,
//                     borderRadius: 6,
//                     backgroundColor: "#fafafa",
//                     minHeight: 60
//                   }}
//                 >
//                   {(userAnswers[q.id] || q.answers.map((a, i) => ({ id: `a-${i}`, text: a.text }))).map((item, index) => (
//                     <Draggable key={item.id} draggableId={item.id} index={index}>
//                       {(provided) => (
//                         <div
//                           ref={provided.innerRef}
//                           {...provided.draggableProps}
//                           {...provided.dragHandleProps}
//                           style={{
//                             padding: "8px 12px",
//                             marginBottom: 8,
//                             background: "#fff",
//                             border: "1px solid #d9d9d9",
//                             borderRadius: 4,
//                             ...provided.draggableProps.style,
//                           }}
//                         >
//                           {item.text}
//                         </div>
//                       )}
//                     </Draggable>
//                   ))}
//                   {provided.placeholder}
//                 </div>
//               )}
//             </Droppable>
//           </DragDropContext>
//         )}

//         {submitted && (
//           <div style={{ marginTop: 12 }}>
//             {isCorrect ? (
//               <Alert
//                 type="success"
//                 message={<span><CheckCircleTwoTone twoToneColor="#52c41a" /> Bonne réponse</span>}
//                 description="Explication : Pas d'explication disponible."
//                 showIcon
//               />
//             ) : (
//               <Alert
//                 type="error"
//                 message={<span><CloseCircleTwoTone twoToneColor="#ff4d4f" /> Mauvaise réponse</span>}
//                 description="Explication : Pas d'explication disponible."
//                 showIcon
//               />
//             )}
//           </div>
//         )}
//       </Card>
//     );
//   };

//   return (
//     <div style={{ marginTop: 24 }}>
//       <Divider />
//       <Title level={5}>🤔 Quiz - {subject?.title}</Title>

//       {loading ? (
//         <div style={{ textAlign: "center", padding: 20 }}>
//           <Spin size="large" tip="Chargement du quiz..." />
//         </div>
//       ) : (
//         <>
//           {questions.map(renderQuestion)}

//           {!submitted && (
//             <div style={{ textAlign: "center", marginTop: 20 }}>
//               <Button type="primary" onClick={handleSubmit}>Soumettre le Quiz</Button>
//             </div>
//           )}

//           {submitted && (
//             <div style={{ textAlign: "center", marginTop: 20 }}>
//               <Button onClick={() => {
//                 setSubmitted(false);
//                 setUserAnswers({});
//               }}>Recommencer</Button>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default QuizzesSubject;


// **** code de mattching type *****
import React, { useState } from "react";
import {
  Button,
  Typography,
  Spin,
  Divider,
  Alert,
  Radio,
  Checkbox,
  Card,
} from "antd";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MatchingQuestionViewer from "./MatchingQuestionViewer";

const { Title } = Typography;

const QuizzesSubject = ({ subject, courseId, onSubmitResult }) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [userAnswers, setUserAnswers] = useState({});

  const quizzes = subject?.quizzes || [];
  if (!quizzes.length) return null;

  const currentQuiz = quizzes[0];
  const questions = currentQuiz?.questions || [];

  const handleSubmit = () => {
    setSubmitted(true);
    let correctCount = 0;

    questions.forEach((q) => {
      const correctAnswers = q.answers.filter((a) => a.correct).map((a) => a.text.trim());
      const user = userAnswers[q.id];

      let isCorrect = false;

      if (q.type === "DRAG_DROP") {
        const userTexts = Array.isArray(user) ? user.map((u) => u.text.trim()) : [];
        isCorrect = JSON.stringify(userTexts) === JSON.stringify(correctAnswers);
      } else if (q.type === "MATCHING") {
        const pairs = q.answers;
        const leftItems = pairs.filter((_, i) => i % 2 === 0).map(p => p.text.trim());
        const rightItems = pairs.filter((_, i) => i % 2 === 1).map(p => p.text.trim());

        isCorrect = leftItems.every(
          (left, idx) => user?.[left] === rightItems[idx]
        );
      } else if (Array.isArray(user)) {
        isCorrect = JSON.stringify(user.sort()) === JSON.stringify(correctAnswers.sort());
      } else {
        isCorrect = user === correctAnswers[0];
      }

      if (isCorrect) correctCount++;
    });

    const score = correctCount * 10;
    const isPassed = score > 0;

    if (onSubmitResult) {
      onSubmitResult(subject.id, isPassed);
    }
  };

  const renderQuestion = (q) => {
    const correctAnswers = q.answers.filter((a) => a.correct).map((a) => a.text);
    const user = userAnswers[q.id];
    const isCorrect = Array.isArray(user)
      ? JSON.stringify(user.sort()) === JSON.stringify(correctAnswers.sort())
      : user === correctAnswers[0];

    return (
      <Card key={q.id} style={{ marginBottom: 16 }}>
        <Title level={5}>{q.text}</Title>

        {q.type === "QCM" && (
          <Checkbox.Group
            value={userAnswers[q.id] || []}
            onChange={(vals) => setUserAnswers({ ...userAnswers, [q.id]: vals })}
            disabled={submitted}
            style={{ display: "flex", flexDirection: "column", gap: 8 }}
          >
            {q.answers.map((a, i) => (
              <Checkbox key={i} value={a.text}>{a.text}</Checkbox>
            ))}
          </Checkbox.Group>
        )}

        {(q.type === "QCU" || q.type === "VRAI_FAUX") && (
          <Radio.Group
            value={userAnswers[q.id]}
            onChange={(e) => setUserAnswers({ ...userAnswers, [q.id]: e.target.value })}
            disabled={submitted}
            style={{ display: "flex", flexDirection: "column", gap: 8 }}
          >
            {q.answers.map((a, i) => (
              <Radio key={i} value={a.text}>{a.text}</Radio>
            ))}
          </Radio.Group>
        )}

        {q.type === "MATCHING" && (
          <MatchingQuestionViewer
            key={submitted + JSON.stringify(userAnswers[q.id] || {})}
            pairs={q.answers || []}
            questionId={q.id}
            userAnswers={userAnswers}
            setUserAnswers={setUserAnswers}
            disabled={submitted}
          />
        )}

        {q.type === "DRAG_DROP" && (
          <DragDropContext
            onDragEnd={(result) => {
              if (!result.destination) return;

              const items = [...(userAnswers[q.id] || q.answers.map((a, i) => ({ id: `a-${i}`, text: a.text })))];
              const [removed] = items.splice(result.source.index, 1);
              items.splice(result.destination.index, 0, removed);

              setUserAnswers({ ...userAnswers, [q.id]: items });
            }}
          >
            <Droppable droppableId={`droppable-${q.id}`}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{
                    border: "1px solid #f0f0f0",
                    padding: 12,
                    borderRadius: 6,
                    backgroundColor: "#fafafa",
                    minHeight: 60,
                  }}
                >
                  {(userAnswers[q.id] || q.answers.map((a, i) => ({ id: `a-${i}`, text: a.text }))).map((item, index) => (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            padding: "8px 12px",
                            marginBottom: 8,
                            background: "#fff",
                            border: "1px solid #d9d9d9",
                            borderRadius: 4,
                            ...provided.draggableProps.style,
                          }}
                        >
                          {item.text}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}

        {submitted && (
          <div style={{ marginTop: 12 }}>
            {isCorrect ? (
              <Alert
                type="success"
                message={<span><CheckCircleTwoTone twoToneColor="#52c41a" /> Bonne réponse</span>}
                description="Explication : Pas d'explication disponible."
                showIcon
              />
            ) : (
              <Alert
                type="error"
                message={<span><CloseCircleTwoTone twoToneColor="#ff4d4f" /> Mauvaise réponse</span>}
                description="Explication : Pas d'explication disponible."
                showIcon
              />
            )}
          </div>
        )}
      </Card>
    );
  };

  return (
    <div style={{ marginTop: 24 }}>
      <Divider />
      <Title level={5}>🤔 Quiz - {subject?.title}</Title>

      {loading ? (
        <div style={{ textAlign: "center", padding: 20 }}>
          <Spin size="large" tip="Chargement du quiz..." />
        </div>
      ) : (
        <>
          {questions.map(renderQuestion)}

          {!submitted && (
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Button type="primary" onClick={handleSubmit}>
                Soumettre le Quiz
              </Button>
            </div>
          )}

          {submitted && (
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Button
                onClick={() => {
                  setSubmitted(false);
                  setUserAnswers({});
                }}
              >
                Recommencer
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default QuizzesSubject;
